module.exports = __webpack_public_path__ + "img/green.3d87bc34.svg";